<template>
  <ul class="cs-1depth" id="contents">
    <li
      v-for="(tab, index) in tabList"
      :key="index"
      :class="setTabCss(tab.name)"
    >
      <router-link :to="tab.link">{{ tab.title }}</router-link>
    </li>
  </ul>
</template>

<script setup>
  import cookie from '@/common/utils/cookie'
  import { useRoute } from 'vue-router/composables'

  const route = useRoute()
  const isWavveOn = cookie.isWavveOn()

  const defaultTabList = [
    { title: '공지사항', link: '/customer/notice_list', name: 'notice' },
    { title: '자주 묻는 질문 FAQ', link: '/customer/faq', name: 'faq' },
    { title: '1:1 문의', link: '/customer/user_qna', name: 'user_qna' },
    { title: '이용약관', link: '/customer/agreement', name: 'agreement' },
  ]

  const tabList = isWavveOn
    ? defaultTabList.filter((tab) => tab.name !== 'user_qna')
    : defaultTabList

  const setTabCss = (tab) => {
    return route.meta.tab === tab ? 'customer-1depth-on' : ''
  }
</script>
